// extracted by mini-css-extract-plugin
export default {"nearbyPOIContainer":"NearbyPOI-module__nearbyPOIContainer___1QSkb"};